import { combineReducers } from 'redux';
// import redPost from './redPost';
import redAuth from './redAuth';
import redTheme from './redTheme';
import redCustomer from './redCustomer';

export default combineReducers({ redAuth, redTheme, redCustomer });
